import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Text} from '../Text';

export const TermsAndConditionsHeader: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const {t} = useTranslation();

  return (
    <HeaderText>{children || t('Promotion Terms & Conditions')}</HeaderText>
  );
};

export const TermsAndConditionsBody: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <BodyText>{children}</BodyText>;
};

const HeaderText = styled(Text)`
  flex: 1;
  margin-top: 16px;
  font-size: ${FONT_SIZES.px16};
  font-weight: ${FONT_WEIGHTS.light};
  color: ${COLORS.Black};
  line-height: 1.4;
`;

const BodyText = styled(Text)`
  margin: 0 24px 24px 24px;
  font-size: ${FONT_SIZES.px14};
  line-height: 1.4;
`;
